module.exports = __webpack_public_path__ + "static/media/cavern_of_the_see.e7d5d925.png";